// The hidden next/from fields the timecard detail publishes for the forms that
// are built in JS rather than rendered server-side (action-confirm,
// reject-reason). They tell the shared bulk endpoint which card to open once the
// action succeeds — see Cup::Timecards::Detail::Component and
// TimecardsBulkAction#jump_target.
//
// A no-op anywhere else: on a screen without a timecard detail there is nothing
// to append, and the endpoints then simply redirect back the way they always did.
export function appendJumpFields(controller, form) {
  const element = document.querySelector("[data-controller~='timecard-jump']")
  if (!element) return

  const jump = controller.application.getControllerForElementAndIdentifier(element, "timecard-jump")
  jump?.appendTo(form)
}
